import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="text-center mb-16">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">
          Scopri il Database Aggiornato
        </h2>
        <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base mb-8">
          Accedi subito a Itaobuy Spreadsheet e inizia a trovare i migliori prodotti. Migliaia di articoli verificati ti aspettano.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-primary-500 text-base font-semibold text-background-50 hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            Itaobuy Sheet
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <Link
            to="/guida-itaobuy-spreadsheet"
            className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-secondary-100 text-base font-semibold text-secondary-900 hover:bg-secondary-200 transition-all cursor-pointer whitespace-nowrap"
          >
            Leggi la Guida
            <i className="ri-arrow-right-line text-lg"></i>
          </Link>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-0">
        <img
          src="https://readdy.ai/api/search-image?query=Single%20luxury%20running%20sneaker%20with%20metallic%20accents%20on%20warm%20cream%20surface%2C%20soft%20window%20lighting%20from%20left%2C%20minimal%20product%20photography%2C%20isolated%20product%20shot%2C%20neutral%20beige%20background%2C%20clean%20modern%20ecommerce%20style%2C%20warm%20sand%20tones%2C%20subtle%20reflection%20on%20glossy%20surface&width=220&height=220&seq=banner-product-01-v2&orientation=squarish"
          alt="Prodotto Itaobuy 1"
          title="Itaobuy Spreadsheet - Sneakers"
          className="w-28 h-28 md:w-36 md:h-36 object-cover object-top"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Single%20designer%20crossbody%20bag%20in%20cognac%20leather%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20isolated%20product%20shot%2C%20neutral%20beige%20background%2C%20luxury%20accessory%20catalog%20style%2C%20warm%20earth%20tones%2C%20elegant%20composition&width=220&height=220&seq=banner-product-02-v2&orientation=squarish"
          alt="Prodotto Itaobuy 2"
          title="Itaobuy Spreadsheet - Borse"
          className="w-28 h-28 md:w-36 md:h-36 object-cover object-top"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Single%20elegant%20wristwatch%20with%20leather%20strap%20on%20warm%20cream%20surface%2C%20soft%20natural%20side%20lighting%2C%20minimal%20product%20photography%2C%20isolated%20product%20shot%2C%20neutral%20beige%20background%2C%20luxury%20accessory%20catalog%20style%2C%20warm%20gold%20and%20brown%20tones&width=220&height=220&seq=banner-product-03-v2&orientation=squarish"
          alt="Prodotto Itaobuy 3"
          title="Itaobuy Spreadsheet - Orologi"
          className="w-28 h-28 md:w-36 md:h-36 object-cover object-top"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Single%20premium%20cashmere%20sweater%20in%20warm%20oatmeal%20color%20on%20cream%20textured%20surface%2C%20soft%20natural%20lighting%20from%20window%2C%20minimal%20product%20photography%2C%20isolated%20product%20shot%2C%20neutral%20beige%20background%2C%20clean%20fashion%20catalog%20style%2C%20gentle%20fabric%20texture&width=220&height=220&seq=banner-product-04-v2&orientation=squarish"
          alt="Prodotto Itaobuy 4"
          title="Itaobuy Spreadsheet - Abbigliamento"
          className="w-28 h-28 md:w-36 md:h-36 object-cover object-top"
        />
        <img
          src="https://readdy.ai/api/search-image?query=Single%20pair%20of%20designer%20sunglasses%20with%20gold%20frame%20on%20warm%20cream%20surface%2C%20soft%20natural%20side%20lighting%2C%20minimal%20product%20photography%2C%20isolated%20product%20shot%2C%20neutral%20beige%20background%2C%20luxury%20accessory%20catalog%20style%2C%20warm%20earth%20tones&width=220&height=220&seq=banner-product-05-v2&orientation=squarish"
          alt="Prodotto Itaobuy 5"
          title="Itaobuy Spreadsheet - Accessori"
          className="w-28 h-28 md:w-36 md:h-36 object-cover object-top"
        />
      </div>
    </section>
  );
}